<script>
  // import type { IPageData } from "../../core";
  import axios from "axios";
  import { navigateTo } from "../../core";

  // export let data: IPageData;

  axios.get("/api/Customer/current").then(() => {
    navigateTo("/");
  });
</script>

<main class="page-content">
  <div class="auth-layout-background" />

  <div class="auth-layout-wrapper">
    <div class="auth-layout">
      <div class="auth-layout-header">
        <svg class="logo" width="233" height="28" aria-label="logotype">
          <use xlink:href="#logo-color" />
        </svg>
      </div>
      <div class="auth-layout-content">
        <slot />
      </div>
    </div>
  </div>
</main>

<style lang="scss">
  .page-content {
    position: relative;
  }
  .auth-layout-background {
    @include absolute-wrapper;
    background-size: cover;
    background-color: $key-color;
  }
  .auth-layout-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .auth-layout {
    width: calc(100% - 44px);
    max-width: 450px;
    margin-top: 15%;
    margin-bottom: 30px;
    background: $background-color;
  }
  .auth-layout-header {
    background: $text-reverse-color;
    padding: 32px;
    display: flex;
    justify-content: center;
  }
  .auth-layout-content {
    padding: 30px 40px 45px;
  }
</style>
